import React from 'react';
import {
  FaLightbulb, FaCheckSquare, FaQuestionCircle,
  FaBookOpen, FaBookReader, FaPlayCircle, FaComments, FaPenFancy,
  FaLayerGroup
} from "react-icons/fa";

import './LessonActivityCard.css';

/**
 * One theme per activity type. Grammar pages and topic pages share this map so
 * the same activity always gets the same colour, icon and label, whichever
 * page it is rendered on. Exported from here because it is the canonical
 * label/icon source for both the lesson shell and the listing cards.
 */
export const activityThemes = {
  grammarexplanation: { bg: '#D7BDE2', text: '#000', icon: FaLightbulb, label: 'Language Point' },
  grammar:            { bg: '#D7BDE2', text: '#000', icon: FaPenFancy,  label: 'Grammar Practice' },
  grammarquiz:        { bg: '#A7D271', text: '#000', icon: FaCheckSquare, label: 'Language Practice' },
  quiz:               { bg: '#A7D271', text: '#000', icon: FaCheckSquare, label: 'Quiz' },
  triviaquiz:         { bg: '#F9E79F', text: '#000', icon: FaQuestionCircle, label: 'Trivia Quiz' },
  vocab:              { bg: '#95E1D3', text: '#333', icon: FaBookOpen,  label: 'Vocabulary' },
  reading:            { bg: '#FADED9', text: '#000', icon: FaBookReader, label: 'Reading' },
  video:              { bg: '#AED6F1', text: '#000', icon: FaPlayCircle, label: 'Video' },
  discussion:         { bg: '#EFE3F1', text: '#000', icon: FaComments, label: 'Discussion' },
  categorization:     { bg: '#F5CBA7', text: '#000', icon: FaLayerGroup, label: 'Sorting' },
  answers:            { bg: '#D5F5E3', text: '#000', icon: FaPenFancy,  label: 'Student Answers' },
};

const fallbackTheme = { bg: '#eee', text: '#000', icon: FaLightbulb, label: 'Activity' };

/**
 * Static (never collapsible) wrapper for a single activity inside a lesson.
 *
 * This is the in-lesson activity block, not a listing card: it has no border,
 * radius or shadow of its own because the lesson panel supplies the surface.
 * The listing cards live in Components/cards/ActivityCard.jsx and share
 * nothing with this file.
 *
 * `plain` drops the tinted background and the icon header. Defaults to false,
 * so anything still relying on the tint keeps working.
 */
const LessonActivityCard = ({ type, label, children, plain = false }) => {
  const theme = activityThemes[type] || fallbackTheme;
  const Icon = theme.icon;

  return (
    <div
      className={`lesson-activity${plain ? ' lesson-activity--plain' : ''}`}
      style={plain ? undefined : { backgroundColor: theme.bg, color: theme.text }}
    >
      {!plain && (
        <div className="lesson-activity__header">
          <Icon className="lesson-activity__icon" aria-hidden="true" />
          <span>{label || theme.label}</span>
        </div>
      )}

      <div className="lesson-activity__body">
        {children}
      </div>
    </div>
  );
};

export default LessonActivityCard;